import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-112" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-113" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-114" data-mp="3ghc2o28413o8">Court Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-115" data-mp="32lrk57wamnhc">
          The Four-Block Session System for Pickleball Coaches — every player
          moving, every level on the same court.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-116" data-mp="3ucxsgbm63rhp">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-117" data-mp="36d1erw44jko">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-118" data-mp="29yxdpewb9omv">
          Court Ready is a session-planning resource for pickleball coaches. It
          does not replace a coaching certification, first-aid training or
          medical advice. Coaches are responsible for adapting every session to
          their players, courts and local regulations. Results depend on the
          coach and the group; no specific outcome is guaranteed. Court Ready is
          an independent product and is not affiliated with or endorsed by any
          pickleball governing body, certification organization or brand.
          © Court Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}